import { Outlet } from 'react-router-dom';

// Minimal shell for unauthenticated screens (login, forgot password) —
// no sidebar, no data fetching, so it never depends on auth state.
export function AuthLayout() {
  return (
    <div className="auth-shell">
      <Outlet />
    </div>
  );
}
